'use strict';

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
	var resolver = this;

	if (catcher === true) {
		if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
			var _tasks = [];

			if (!tick) {
				try {
					tick = process.nextTick;
				} catch (ex) {
					tick = function tick(p) {
						setTimeout(p, 0);
					};
				}
			}

			function _untask() {
				for (var i = 0; i < _tasks.length; i += 2) {
					var t = _tasks[i + 1],
					    r = _tasks[i];

					for (var j = 0; j < t.length; j++) {
						t[j].call(null, r);
					}
				}

				_tasks = [];
			}

			function isThenable(obj) {
				return obj && obj instanceof Object && typeof obj.then === 'function';
			}

			function EagerThenable(resolver) {
				function done(inline) {
					var w;
					if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

					_tasks.push(result, w);

					_thens = [[], []];
					if (_tasks.length === 2) inline ? _untask() : tick(_untask);
				}

				function resolveThen(x) {
					if (isThenable(x)) return x.then(resolveThen, rejectThen);
					phase = 0;
					result = x;
					done(true);
				}

				function rejectThen(x) {
					if (isThenable(x)) return x.then(resolveThen, rejectThen);
					phase = 1;
					result = x;
					done(true);
				}

				function settler(resolver, rejecter) {
					_thens[0].push(resolver);

					_thens[1].push(rejecter);

					done();
				}

				function toString() {
					return 'EagerThenable{' + {
						'-1': 'pending',
						0: 'resolved',
						1: 'rejected'
					}[phase] + '}=' + result.toString();
				}

				this.then = settler;
				this.toString = toString;
				var _thens = [[], []],
				    _sync = true,
				    phase = -1,
				    result;
				resolver.call(null, resolveThen, rejectThen);
				_sync = false;
				done();
			}

			EagerThenable.resolve = function (v) {
				return isThenable(v) ? v : {
					then: function then(resolve, reject) {
						return resolve(v);
					}
				};
			};

			return EagerThenable;
		}();
		return new Function.prototype.$asyncbind.EagerThenable(boundThen);
	}

	if (catcher) {
		if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
		return then;
	}

	function then(result, error) {
		try {
			return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
		} catch (ex) {
			return (error || catcher)(ex);
		}
	}

	function boundThen(result, error) {
		return resolver.call(self, result, error);
	}

	boundThen.then = boundThen;
	return boundThen;
};

/**
 * @author RubaXa <trash@rubaxa.org>
 * @licence MIT
 */

var ReactDOM = require('react-dom');

(function (factory) {
	'use strict';

	if (typeof module != 'undefined' && typeof module.exports != 'undefined') {
		module.exports = factory(require('sortablejs/Sortable'));
	} else if (typeof define === 'function' && define.amd) {
		define(['sortablejs/Sortable'], factory);
	} else {
		/* jshint sub:true */
		window['SortableMixin'] = factory(Sortable);
	}
})(function ( /** Sortable */Sortable) {
	'use strict';

	var _nextSibling;

	var _activeComponent;

	var _defaultOptions = {
		ref: 'list',
		model: 'items',

		animation: 100,
		onStart: 'handleStart',
		onEnd: 'handleEnd',
		onAdd: 'handleAdd',
		onUpdate: 'handleUpdate',
		onRemove: 'handleRemove',
		onSort: 'handleSort',
		onFilter: 'handleFilter',
		onMove: 'handleMove',
		onClone: 'handleClone'
	};

	function _getModelName(component) {
		return component.sortableOptions && component.sortableOptions.model || _defaultOptions.model;
	}

	function _getModelItems(component) {
		var name = _getModelName(component),
		    items = component.state && component.state[name] || component.props[name];

		return items.slice();
	}

	function _extend(dst, src) {
		for (var key in src) {
			if (src.hasOwnProperty(key)) {
				dst[key] = src[key];
			}
		}

		return dst;
	}

	/**
  * Simple and easy mixin-wrapper for rubaxa/Sortable library, in order to
  * make reorderable drag-and-drop lists on modern browsers and touch devices.
  *
  * @mixin
  */
	var SortableMixin = {
		sortableMixinVersion: '0.1.2',

		/**
   * @type {Sortable}
   * @private
   */
		_sortableInstance: null,

		componentDidMount: function componentDidMount() {
			var DOMNode,
			    options = _extend(_extend({}, _defaultOptions), this.sortableOptions || {}),
			    copyOptions = _extend({}, options),
			    emitEvent = function ( /** string */type, /** Event */evt) {
				var method = options[type];
				if (method && typeof method === "string") {
					method = this[method];
				}
				method && typeof method === "function" && method.call(this, evt, this._sortableInstance);
			}.bind(this);

			// Bind callbacks so that "this" refers to the component
			'onStart onEnd onAdd onSort onUpdate onRemove onFilter onMove onClone'.split(' ').forEach(function ( /** string */name) {
				copyOptions[name] = function (evt) {
					if (name === 'onStart') {
						_nextSibling = evt.item.nextElementSibling;
						_activeComponent = this;
					} else if (name === 'onAdd' || name === 'onUpdate') {
						evt.from.insertBefore(evt.item, _nextSibling);

						var newState = {},
						    remoteState = {},
						    oldIndex = evt.oldIndex,
						    newIndex = evt.newIndex,
						    items = _getModelItems(this),
						    remoteItems,
						    item;

						if (name === 'onAdd') {
							remoteItems = _getModelItems(_activeComponent);
							item = remoteItems.splice(oldIndex, 1)[0];
							items.splice(newIndex, 0, item);

							if (_activeComponent._sortableInstance.lastPullMode != 'clone') {
								remoteState[_getModelName(_activeComponent)] = remoteItems;
							} else {
								//FIXME clone的时候造成react操作removeChild报错
								evt.from.contains(evt.item) && evt.from.removeChild(evt.item);
							}
						} else {
							items.splice(newIndex, 0, items.splice(oldIndex, 1)[0]);
						}

						newState[_getModelName(this)] = items;

						if (copyOptions.stateHandler) {
							this[copyOptions.stateHandler](newState);
						} else {
							this.setState(newState);
						}

						this !== _activeComponent && _activeComponent.setState(remoteState);
					}

					setTimeout(function () {
						emitEvent(name, evt);
					}, 0);
				}.bind(this);
			}, this);

			DOMNode = 'getDOMNode' in this ? ReactDOM.findDOMNode(this.refs[options.ref] || this) : this.refs[options.ref] || this;

			/** @namespace this.refs — http://facebook.github.io/react/docs/more-about-refs.html */
			this._sortableInstance = Sortable.create(DOMNode, copyOptions);
		},

		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			var newState = {},
			    modelName = _getModelName(this),
			    items = nextProps[modelName];

			if (items) {
				newState[modelName] = items;
				this.setState(newState);
			}
		},

		componentWillUnmount: function componentWillUnmount() {
			this._sortableInstance.destroy();
			this._sortableInstance = null;
		}
	};

	// Export
	return SortableMixin;
});